import type { CSSProperties } from 'styled-components';
import { Position } from 'core/flow/entities';

type KebabCaseFromCamelCase<S extends string> = S extends `${infer TFirstChar}${infer TRest}`
  ? TFirstChar extends Uppercase<TFirstChar>
    ? `-${Lowercase<TFirstChar>}${KebabCaseFromCamelCase<TRest>}`
    : `${TFirstChar}${KebabCaseFromCamelCase<TRest>}`
  : S;

type KebabCSSProperties = {
  [K in keyof CSSProperties as KebabCaseFromCamelCase<K>]: CSSProperties[K];
};

export const rtlPropertiesMixin = (properties: Partial<KebabCSSProperties>) => `
  [dir="rtl"] & {
    ${Object.entries(properties)
      .map(
        ([prop, value]) => `
      /*! @noflip */
      ${prop}: ${value};
      `,
      )
      .join('\n')}
  }
`;

export const blurWrappedText = () => `
  span {
    filter: blur(4px);
    user-select: none;
  }
`;

export const contentPositionMixin = (position?: Position) => {
  if (position !== Position.BOTTOM) {
    return '';
  }

  return `
    flex-grow: 0;
    height: auto;
    margin-top: auto;
  `;
};
